import { defineMessages } from "react-intl";

const messages = defineMessages({
    createYourAccount: {
        description: "Heading for the registration form",
        defaultMessage: "Create your account"
    },
    signInDescription: {
        description: "Description text below the registration heading",
        defaultMessage: "Choose how you'd like to sign in."
    },
    or: {
        description: "Divider text between Google sign-in and form",
        defaultMessage: "or"
    },
    headerReviewTerms: {
        description: "Header for Google sign-up form when only reviewing terms",
        defaultMessage: "Review the terms to sign up"
    },
    headerSetUpAccount: {
        description: "Header for Google sign-up form that collects organization name and reviews terms",
        defaultMessage: "Set up your account"
    },
    googleFormDescription: {
        description: "Description text below the Google sign-up form heading",
        defaultMessage: "Last step — tell us where you work so we can tailor your trial."
    },
    googleFormDescriptionTermsOnly: {
        description: "Description text below the Google sign-up form heading when only reviewing terms (no company name field)",
        defaultMessage: "Almost there — review and accept the terms to complete your signup."
    },
    backToSignUp: {
        description: "Link to go back to sign up options from Google form",
        defaultMessage: "Back to sign up options"
    },
    logIn: {
        description: "Link to log in from Google sign-up form",
        defaultMessage: "Log in"
    }
});

export default messages;
